import { Icon, type IconTone } from './Icon';

/**
 * Что изменилось: плюс над чертой — прибавили и убрали.
 *
 * Фигура из набора lucide (ISC), знак `diff`: им правку показывают везде, и
 * на тринадцати пикселях он читается, в отличие от листа с перегородкой,
 * который пробовали до него.
 */
export function DiffIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={24} strokeWidth={2} tone={tone}>
      <path d="M12 3v14" />
      <path d="M5 10h14" />
      <path d="M5 21h14" />
    </Icon>
  );
}
